import { ShieldCheck } from "lucide-react";

/** Green on-chain-verified badge: mint + freeze authority revoked. */
export default function RugProofBadge({ coin, compact = false }) {
  if (!coin.rug_safe) return null;
  return (
    <span
      data-testid="rug-proof-badge"
      title="Verified on-chain: mint authority revoked (supply forever capped) and freeze authority revoked (wallets can't be frozen)."
      className={`inline-flex items-center gap-1 border border-[#00ff41] text-[#00ff41] bg-[#00ff41]/10 uppercase tracking-widest font-mono ${
        compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"
      }`}
    >
      <ShieldCheck size={compact ? 9 : 11} /> Rug-proof
    </span>
  );
}
